import { Container, Typography } from '@cleartrip/ct-design-components'
import Image from 'next/image'
import React, { useEffect, useState } from 'react'

import styles from '@/components/srp/Loaders/FindingFlightsLoader/findingFlightsLoader.module.scss'
import { isSrpThemeCabin } from '@/constants/flights/premiumEconomy'

const CDN_BASE = 'https://rukmini-ct.flixcart.com/f_auto,q_auto'
const PLANE_IMG_URL = `${CDN_BASE}/offermgmt-prod/offermgmt/images/flights-plane.png`
/** Premium economy, business and first share one coloured plane, as on flights-pwa. */
const PLANE_IMG_URL_PREMIUM = `${CDN_BASE}/offermgmt-prod/offermgmt/images/premiumEconomy/flight.png`
const CLOUD_IMG_URL = `${CDN_BASE},w_325,h_256/offermgmt-prod/offermgmt/images/finding-flights-cloud-image.png`

const LOADING_MESSAGES = ['Finding best flights...', 'Checking best deals...', 'Preparing your list...']
/** Seconds each message stays up before the slider moves on. */
const MESSAGE_DURATIONS = [2, 3, 3]
/** Matches the 20px line height plus the 8px slider gap. */
const MESSAGE_OFFSET = 28

const CLOUD_TILES = [0, 1, 2, 3, 4, 5]


/** The flights-pwa SRP loader: a bobbing plane over scrolling clouds, with cycling copy. */
const FindingFlightsLoader = ({ cabinClass }: { cabinClass?: string }) => {
  const [messageIndex, setMessageIndex] = useState(0)
  const isThemeCabin = isSrpThemeCabin(cabinClass)
  const planeSrc = isThemeCabin ? PLANE_IMG_URL_PREMIUM : PLANE_IMG_URL
  const planeClassName = isThemeCabin ? `${styles.ffl__planeImg} ${styles.ffl__planeImgSolid}` : styles.ffl__planeImg

  useEffect(() => {
    const timer = setTimeout(
      () => setMessageIndex(prev => (prev + 1) % LOADING_MESSAGES.length),
      MESSAGE_DURATIONS[messageIndex] * 1000
    )
    return () => clearTimeout(timer)
  }, [messageIndex])

  const sliderStyle = { transform: `translateY(-${messageIndex * MESSAGE_OFFSET}px)` }

  return (
    <Container className={styles.ffl}>
      <Container className={styles.ffl__visual}>
        <Container className={styles.ffl__ellipse} />

        <Container className={styles.ffl__clouds}>
          {CLOUD_TILES.map(tile => (
            <Container key={tile} className={styles.ffl__cloudTile}>
              <Image priority alt='' className={styles.ffl__cloudImg} height={256} src={CLOUD_IMG_URL} width={325} />
            </Container>
          ))}
        </Container>

        <Container className={styles.ffl__planeFrame}>
          <Image priority alt='' className={planeClassName} height={250} src={planeSrc} width={250} />
        </Container>
      </Container>

      <Container className={styles.ffl__textArea}>
        <Container className={styles.ffl__textSlider} css={sliderStyle}>
          {LOADING_MESSAGES.map(message => (
            <Typography key={message} className={styles.ffl__textItem} color="subheading" variant='B2'>
              {message}
            </Typography>
          ))}
        </Container>
      </Container>
    </Container>
  )
}

export default FindingFlightsLoader
